/**
 * PI linked (`payload_create`, snapshot in `newValue`) or unlinked
 * (`payload_delete`, snapshot in `prevValue`). The snapshot only carries ids;
 * name and sequential id come from the labels the BFF adds to the detail.
 */
const CampaignCheckingAccount = ({
  piName,
  piSequentialId
}: DefaultChangeProps) => {
  const hasSequentialId = piSequentialId != null

  if (!piName && !hasSequentialId) return null

  return (
    <p className="notes" style={{ display: 'flex', flexDirection: 'column' }}>
      {!!piName && (
        <small className="piName" style={{ overflowWrap: 'anywhere' }}>
          <strong>{piName}</strong>
        </small>
      )}
      {hasSequentialId && (
        <small className="piSequentialId">
          <strong>ID:</strong> {piSequentialId}
        </small>
      )}
    </p>
  )
}

export default CampaignCheckingAccount
